const Data = [
    {
        img: "/assets/doors/door1.jpg",
        category: "product_door_main_pro"
    },
    {
        img: "/assets/doors/door2.jpg",
        category: "product_door_main_pro"
    },
    {
        img: "/assets/doors/door3.jpg",
        category: "product_door_main_pro"
    },
    {
        img: "/assets/doors/door4.jpg",
        category: "product_door_main_pro"
    },
    {
        img: "/assets/doors/door5.jpg",
        category: "product_door_extra_home"
    },
    {
        img: "/assets/doors/door6.jpg",
        category: "product_door_extra_home"
    },
    {
        img: "/assets/doors/door7.jpg",
        category: "product_door_extra_home"
    },
    {
        img: "/assets/doors/door8.jpg",
        category: "product_door_extra_home"
    },
    {
        img: "/assets/doors/door9.jpg",
        category: "product_door_extra_pro"
    },
    { img: "/assets/doors/door10.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door11.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door12.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door13.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door14.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door15.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door16.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door17.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door18.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door19.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door20.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door21.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door22.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door23.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door24.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door25.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door26.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door27.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door28.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door29.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door30.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door31.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door32.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door33.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door34.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door35.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door36.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door37.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door38.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door39.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door40.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door41.jpg", category: "product_door_extra_pro" },
    { img: "/assets/doors/door42.jpg", category: "product_door_extra_pro" },


    { img: "/assets/office/office1.jpg", category: "product_office_main_pro" },
    { img: "/assets/office/office2.jpg", category: "product_office_main_pro" },
    { img: "/assets/office/office3.jpg", category: "product_office_extra_home" },
    { img: "/assets/office/office4.jpg", category: "product_office_extra_pro" },
    { img: "/assets/office/office5.jpg", category: "product_office_extra_pro" },
    { img: "/assets/kitchen/kitchen1.jpg", category: "product_kitchen_main_pro" },
    { img: "/assets/kitchen/kitchen2.jpg", category: "product_kitchen_main_pro" },
    { img: "/assets/kitchen/kitchen3.jpg", category: "product_kitchen_extra_home" },
    { img: "/assets/kitchen/kitchen4.jpg", category: "product_kitchen_extra_home" },
    { img: "/assets/kitchen/kitchen5.jpg", category: "product_kitchen_extra_pro" },
    { img: "/assets/cabinate/cabinate1.jpg", category: "product_cabinate_main_pro" },
    { img: "/assets/cabinate/cabinate2.jpg", category: "product_cabinate_main_pro" },
    { img: "/assets/cabinate/cabinate3.jpg", category: "product_cabinate_extra_home" },
    { img: "/assets/cabinate/cabinate4.jpg", category: "product_cabinate_extra_home" },
    { img: "/assets/cabinate/cabinate5.jpg", category: "product_cabinate_extra_pro" },
    { img: "/assets/drawingrooms/drawingroom1.jpg", category: "product_drawingroom_main_pro" },
    { img: "/assets/drawingrooms/drawingroom2.jpg", category: "product_drawingroom_main_pro" },
    { img: "/assets/drawingrooms/drawingroom3.jpg", category: "product_drawingroom_extra_home" },
    { img: "/assets/drawingrooms/drawingroom4.jpg", category: "product_drawingroom_extra_pro" },
    { img: "/assets/drawingrooms/drawingroom5.jpg", category: "product_drawingroom_extra_pro" },
]


export default Data